import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { SettingsIntegrations } from '@/features/settings/integrations'

const searchSchema = z.object({
  xero_status: z.enum(['success', 'error']).optional(),
  xero_message: z.string().optional(),
  xero_tenant: z.string().optional(),
})

export const Route = createFileRoute('/_authenticated/settings/integrations')({
    component: SettingsIntegrations,
  validateSearch: searchSchema,
})
